import React, { FC } from 'react';
import styles from './DropboxIcon.scss';

export const DropboxIcon: FC = () => <div className={styles.dropboxIcon} />;
